import type { CartSnapshot } from '@teo/widget-shared';

let snapshot: CartSnapshot | null = null;

export function resetCartState(): void {
  snapshot = null;
}

export function getCartSnapshot(): CartSnapshot | null {
  if (!snapshot) return null;
  return {
    ...snapshot,
    sources: [...snapshot.sources],
  };
}

export function setCartSnapshot(next: CartSnapshot | null): void {
  snapshot = next
    ? {
        ...next,
        sources: [...next.sources],
      }
    : null;
}

/** True when count / value / currency meaningfully differ. */
export function cartSnapshotChanged(
  prev: CartSnapshot | null,
  next: CartSnapshot | null,
): boolean {
  if (prev == null && next == null) return false;
  if (prev == null || next == null) return true;
  return (
    prev.itemsCount !== next.itemsCount ||
    prev.cartValue !== next.cartValue ||
    prev.currency !== next.currency
  );
}
